<template>
    <!--数字键盘-->

    <transition name="fade-scale">

        <div class="brt-numboard-module" v-if="visible" @click.stop="">

        </div>

    </transition>


</template>

<script>
    export default {
        name: "NumBoard",
        data(){
            return {
                visible:false
            }
        }
    }
</script>

<style scoped>

</style>